var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.test,"height":"500","border":""}},[_c('el-table-column',{attrs:{"prop":"attrName","align":"center","label":"属性名"}},[[_c('span',[_vm._v("默认")])]],2),_c('el-table-column',{attrs:{"prop":"attrValue","align":"center","label":"属性值"}},[[_c('span',[_vm._v("默认")])]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }